module.exports = __webpack_public_path__ + "static/media/amex.e549edf7.svg";